/**
 * Per-tab realtime client id.
 *
 * Each browser tab loads its own module instance, so this lazily-created UUID
 * is stable for the tab's lifetime and unique across tabs — including two tabs
 * of the same user. It rides on the `x-artic-client-id` header of project-
 * planning batch writes; the backend stamps it into the LISTEN/NOTIFY payload,
 * the realtime service forwards it on `work_orders_changed`, and the editor
 * compares it so a tab ignores the echo of its OWN write (no self-flash, no
 * refetch that would revert in-flight edits) while other tabs and other users
 * still update. See `use-project-channel` / `project-planning-editor`.
 */
let clientId: string | null = null;

export function getClientId(): string {
  clientId ??= crypto.randomUUID();
  return clientId;
}

/**
 * Request options stamping this tab's id onto a work-order write
 * (`customFetch` merges these headers). Pass as the generated Orval request
 * function's trailing options argument on every project-planning mutation, so
 * the acting tab recognises — and skips — the realtime echo of its own write.
 */
export function clientIdHeaders(): { headers: { 'x-artic-client-id': string } } {
  return { headers: { 'x-artic-client-id': getClientId() } };
}
